import{css}from'glamor';export var sheetDrawer=css({boxShadow:'0 0 0 9999px rgba(0, 0, 0, 0.25)'}).toString();